import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DialogData {
  options: string[];
}

@Component({
  selector: 'fc-dialog-select-layer',
  templateUrl: './dialog-select-layer.component.html',
  styleUrls: ['./dialog-select-layer.component.scss'],
})
export class DialogSelectLayerComponent {
  selectLayerForm: UntypedFormGroup;
  options: string[];

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<DialogSelectLayerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.options = data.options;
    this.selectLayerForm = this.formBuilder.group({
      layer: [''],
    });
  }

  onYesClick(): void {
    const selectedLayer = this.selectLayerForm.get('layer').value;
    this.dialogRef.close(selectedLayer);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
